import { createSlice } from '@reduxjs/toolkit';
import { LocationStateType } from 'src/types/location';

const initialState: LocationStateType = {
    params: {
        name: '',
        // backUrl: null
    },
    history: [],
};

export const locationSlice = createSlice({
    name: 'location',
    initialState,
    reducers: {
        setLocationParams: (state, action) => {
            state.params = action.payload;
        },
        pushLocation: (state, action) => {
            state.history = [action.payload, ...state.history].slice(0, 10);
        },
        pullLocation: (state) => {
            state.history.shift();
        },
    },
});

export const { setLocationParams, pushLocation, pullLocation } = locationSlice.actions;

export default locationSlice.reducer;
